export default defineNuxtPlugin((nuxtApp) => {
  const store = useNavigationStore()

  nuxtApp.$router.afterEach((to) => {
    const segments = to.fullPath.split("/").filter(Boolean)
    const segmentsLength = segments?.length
    if (segmentsLength > 1) {
      const previousRoute =
        "/" + segments.slice(0, segmentsLength - 1).join("/")
      store.setHistoryStack(previousRoute)
    } else {
      store.setHistoryStack(null)
    }
  })
})
